import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { describe } from 'react-desc';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { textProps } from './props.js';
import { defaultProps } from './defaultProps.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * if we don't care about word break
 * const regx = new RegExp(`.{1,${maxCharacters}}`, 'g')
 * text.match(regx)
 *
 * @param {*} param0
 */

var DSTextWrapper = function DSTextWrapper(_ref) {
  var containerProps = _ref.containerProps,
      className = _ref.className,
      style = _ref.style,
      text = _ref.text,
      maxCharacters = _ref.maxCharacters,
      maxWidth = _ref.maxWidth,
      textEllipsis = _ref.textEllipsis,
      textAlignment = _ref.textAlignment,
      wordBreak = _ref.wordBreak;

  var _convertPropToCssClas = convertPropToCssClassName('text-wrapperRef', className, {
    textEllipsis: textEllipsis,
    textAlignment: textAlignment,
    wordBreak: wordBreak
  }),
      cssClassName = _convertPropToCssClas.cssClassName,
      classNameElement = _convertPropToCssClas.classNameElement;

  var limitPerCharacter = function limitPerCharacter() {
    return text.split(' ').reduce(function (result, word) {
      var resultIndex = result.length - 1;
      if (result[resultIndex].length + word.length > maxCharacters) resultIndex += 1;
      result[resultIndex] = "".concat(result[resultIndex] || '', " ").concat(word);
      return result;
    }, ['']);
  };

  var displayText = text;
  if (textEllipsis) displayText = maxCharacters > 0 ? displayText.substring(0, maxCharacters) : displayText;else if (maxCharacters > 0) {
    displayText = limitPerCharacter().map(function (textpart, index) {
      return /*#__PURE__*/React.createElement("span", {
        key: index,
        className: classNameElement('line')
      }, textpart);
    });
  }
  return /*#__PURE__*/React.createElement("span", _extends({}, containerProps, {
    className: cssClassName,
    style: _objectSpread({
      maxWidth: maxCharacters < 1 ? maxWidth : null
    }, style)
  }), textEllipsis ? /*#__PURE__*/React.createElement("span", {
    className: classNameElement('ellipsis-wrapperRef')
  }, displayText) : displayText);
};

DSTextWrapper.propTypes = textProps;
DSTextWrapper.defaultProps = defaultProps;
var TextWrapperWithSchema = describe(DSTextWrapper);
TextWrapperWithSchema.propTypes = textProps;

export default DSTextWrapper;
export { DSTextWrapper, TextWrapperWithSchema };
//# sourceMappingURL=DSTextWrapper.js.map
